import {
  BasePageModel,
  basePageToLocal
} from '@interface/index';

export interface ExternalType extends BasePageModel {
}

export function externalTypeToLocal(data: any): ExternalType {

  return {
    ...basePageToLocal(data)
  };
}

export function externalTypeToServer(data: ExternalType) {
  return {
    name: data.name,
    inherited_from_composite_id: data.inheritedFromCompositeId
  };
}
